import { SchemaMarkdown } from './SchemaMarkdown.tsx';

export const DeprecationWarning = ({ type }: { type: string }) => (
  <SchemaMarkdown type={type} warning />
);
